import { useTranslation } from "react-i18next";
import DownloadIcon from "~/common/mui/icons/Download";

import { Button, Stack, Typography } from "~/common/mui";
import { ReportType } from "~/features/cart/cart/components/Buttons/DownloadReportButton/api/downloadCartReport";

interface DownloadReportButtonsProps {
  label: string;
  onDownload: (type: ReportType) => void;
  disabled: boolean;
  testIdPrefix: string;
}

export const DownloadReportButtons = ({ onDownload, disabled, label }: DownloadReportButtonsProps) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Typography variant="labelLarge" color="textSecondary">
        {label}
      </Typography>
      <Button
        variant="text"
        startIcon={<DownloadIcon />}
        onClick={() => onDownload(ReportType.XLSX)}
        disabled={disabled}
      >
        {t("downloadFile.type.excel")}
      </Button>
      <Button
        variant="text"
        startIcon={<DownloadIcon />}
        onClick={() => onDownload(ReportType.CSV)}
        disabled={disabled}
      >
        {t("downloadFile.type.csv")}
      </Button>
    </Stack>
  );
};
